import React, { useState, useEffect } from "react";
import { withUserAgent } from "next-useragent";
import Link from "next/link";
import store from "../../../store";
import { shallowEqual, useSelector } from "react-redux";
import { getHeaderComponentData } from "../../../api/header";
import { socialLinks } from "../../../constants";


// import "./style.scss";

function MenuIcon(props) {
  const [openProgramMenu, setOpenProgramMenu] = useState(false);
  const [openAdmissionMenu, setOpenAdmissionMenu] = useState(false);
  const [openCommunityMenu, setOpenCommunityMenu] = useState(false);
  const [openAboutMenu, setOpenAboutMenu] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isApp, setIsApp] = useState(false);
  const [pageData, setPageData] = useState("");
  const { userId } = useSelector(
    (state) => ({
      userId: state.userAuth.userId,
    }),
    shallowEqual
  );

  const { userAuth } = store.getState();

  useEffect(() => {
    if (userAuth.authenticated && userAuth.token) {
      setIsLogin(true);
    }
    if (props.ua.source == "BayanApp") {
      setIsApp(true);
    }
    getHeaderComponentData().then((res) => {
      if (res) {
        setPageData(res);
      }
    });
  }, []);

  const closeAll = () => {
    props.setOpenMenu(false);
    setOpenProgramMenu(false);
    setOpenAdmissionMenu(false);
    setOpenCommunityMenu(false);
    setOpenAboutMenu(false);
  };

  const signOut = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  return (
    <div>
      <div className={`side-menu ${props.openMenu ? "open" : ""}`}>
        <div className="menu-bg"></div>
        <div className="left-side-menu">
          <div className="menu-header">
            <Link href="/" as="/">
              {/* <span className="logo-mob"> */}
              <a onClick={() => props.setOpenMenu(false)}>
                <img src="/icons/bayan-only.svg" width="120" />
                {/* <img src="/icons/logo-in.png"/> BAYAN */}
              </a>
              {/* </span> */}
            </Link>
            <p>ACCREDITED GRADUATE ISLAMIC STUDIES</p>
            <a className="close-icon" onClick={() => closeAll()}></a>
          </div>
          <div className="menu-body">
            <ul className="menu">
              <li onClick={() => props.setOpenMenu(false)}>
                <Link href="/" as="/">
                  <a>Learn More</a>
                </Link>
              </li>
              <li onClick={() => setOpenProgramMenu(true)}>
                <a>
                  {capitalizeFirstLetter(pageData[0]?.nav_menu_heading ?? "")}
                </a>
              </li>
              <li onClick={() => setOpenAdmissionMenu(true)}>
                <a>Admissions</a>
              </li>
              <li onClick={() => props.setOpenMenu(false)}>
                <Link href="/student-resources" as="/student-resources">
                  <a>Students</a>
                </Link>
              </li>
              <li onClick={() => setOpenAboutMenu(true)}>
                <a>About Bayan</a>
              </li>
              <li>
                <a
                  href="https://direct.bayanclaremont.org/courses"
                  target="_blank"
                  alt="Bayan On-Demand"
                >
                  On-Demand
                </a>
              </li>
              <li>
                <a
                  href="https://bayantours.org"
                  target="_blank"
                  alt="Bayan Tours"
                >
                  Tours
                </a>
              </li>
              <li>
                <a href="/shop" target="_blank" alt="Bayan Tours">
                  Shop
                </a>
              </li>
              {/* <li onClick={() => props.setOpenMenu(false)}><Link href="/support" as="/support"><a>DONATE</a></Link></li> */}

              {/* {isLogin ? <> */}
              {/* <li onClick={() => props.setOpenMenu(false)}><Link href="/profile/edit" as="/profile/edit"><a >Edit Profile</a></Link></li>
								<li onClick={() => props.setOpenMenu(false)}><Link href="/home/settings" as="/settings"><a >Settings</a></Link></li> */}
              {/* <li onClick={() => signOut()}><a>Sign Out</a></li> */}
              {/* <li onClick={() => props.setOpenMenu(false)}>
									<div id="donation-content">
										<a id="support-btn" href="#FUNPXTDUDLU"> DONATE </a>
									</div>
								</li> */}
              {/* </> : <li onClick={() => props.setOpenMenu(false)}>
									<div id="donation-content">
										<a id="support-btn" href="#FUNPXTDUDLU"> DONATE </a>
									</div>
								</li>} */}
            </ul>
            <ul className="action-btns">
              <li>
                <Link passHref href="/apply">
                  <a className="active"> APPLY NOW </a>
                </Link>
              </li>
              {/* { (userAuth.authenticated && userAuth.token) ? <></> : <li><Link href="https://www.bayanonline.org/" as="https://www.bayanonline.org/"><a target="_blank" className="">Login to BAYAN ON-DEMAND</a></Link></li>} */}
              <li onClick={() => props.setOpenMenu(false)}>
                <div id="donation-content">
                  {isApp ? (
                    <a id="support-btn" href="/support?app=redirect">
                      {" "}
                      DONATE{" "}
                    </a>
                  ) : (
                    <a id="support-btn" href="#FUNPXTDUDLU">
                      {" "}
                      DONATE{" "}
                    </a>
                  )}
                </div>
              </li>
            </ul>
            {/* <Link href="/login" as="/login"><a className="active"><p className="already-text">Already have an account? Login</p></a></Link> */}
            {/* {isLogin ? (
              <a
                onClick={() => signOut()}
                style={{ justifyContent: "center", display: "flex" }}
              >
                Sign Out
              </a>
            ) : (
              <Link href="/login" as="/login">
                <a className="active">
                  <p className="already-text">Already have an account? Login</p>
                </a>
              </Link>
            )} */}
          </div>
          <div className="menu-footer">
            {/* <Link href="/support" as="/support"><a>DONATE NOW</a></Link> */}
            <p>
              <small>*Secure donations through Network for Good</small>
            </p>
            <p>
              <small>
                © {new Date().getFullYear()} Bayan | All Rights Reserved
              </small>
            </p>
          </div>
          <div className={`menu-mobile-block ${openProgramMenu ? "open" : ""}`}>
            <div className="menu-header">
              <a
                className="backarrow"
                onClick={() => setOpenProgramMenu(false)}
              >
                <img
                  src={`${process.env.IMAGES_BASE_URL}/static-content/arrow.png.webp`}
                  width="14"
                />
              </a>
              <label alt="Degree Programs">
                {pageData[0]?.make_a_menu[0]?.heading ?? ""}
              </label>
              <a className="close-icon" onClick={() => closeAll()}></a>
            </div>
            <div className="menu-body">
              <div className="menu-block">
                <label alt="Degree Programs" onClick={() => closeAll()}>
                  <Link
                    href={pageData[0]?.make_a_menu[0]?.heading_url ?? ""}
                    as={pageData[0]?.make_a_menu[0]?.heading_url_as ?? ""}
                  >
                    <a alt="Degree Programs">
                      {pageData[0]?.make_a_menu[0]?.heading ?? ""}
                    </a>
                  </Link>
                </label>
                <ul>
                  {pageData[0]?.make_a_menu[0]?.inner_menus?.map((item, i) => (
                    <li onClick={() => closeAll()}>
                      <Link
                        key={i}
                        href={item ? item?.label_url : ""}
                        as={item ? item?.label_url_as : ""}
                      >
                        <a>{item?.label ?? ""}</a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="menu-block">
                <label onClick={() => closeAll()}>
                  <Link
                    href={pageData[0]?.make_a_menu[1]?.heading_url ?? ""}
                    as={pageData[0]?.make_a_menu[1]?.heading_url_as ?? ""}
                  >
                    <a alt={pageData[0]?.make_a_menu[1]?.heading ?? ""}>
                      {pageData[0]?.make_a_menu[1]?.heading ?? ""}
                    </a>
                  </Link>
                </label>
                <ul>
                  {pageData[0]?.make_a_menu[1]?.inner_menus?.map((item, i) => (
                    <li onClick={() => closeAll()}>
                      <Link
                        key={i}
                        href={item ? item?.label_url : ""}
                        as={item ? item?.label_url_as : ""}
                      >
                        <a>{item?.label ?? ""}</a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="menu-block">
                <label onClick={() => closeAll()}>
                  <Link
                    href={pageData[0]?.make_a_menu[2]?.heading_url ?? ""}
                    as={pageData[0]?.make_a_menu[2]?.heading_url_as ?? ""}
                  >
                    <a alt={pageData[0]?.make_a_menu[2]?.heading ?? ""}>
                      {pageData[0]?.make_a_menu[2]?.heading ?? ""}
                    </a>
                  </Link>
                </label>
                <ul>
                  {pageData[0]?.make_a_menu[2]?.inner_menus?.map((item, i) => (
                    <li onClick={() => closeAll()}>
                      <Link
                        key={i}
                        href={item ? item?.label_url : ""}
                        as={item ? item?.label_url_as : ""}
                      >
                        <a>{item?.label ?? ""}</a>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`menu-mobile-block ${openAdmissionMenu ? "open" : ""}`}
          >
            <div className="menu-header">
              <a
                className="backarrow"
                onClick={() => setOpenAdmissionMenu(false)}
              >
                <img
                  src="https://d310ox1f4zno4b.cloudfront.net/static-content/arrow.png.webp"
                  width="14"
                />
              </a>
              <label>Admissions</label>
              <a className="close-icon" onClick={() => closeAll()}></a>
            </div>
            <div className="menu-body">
              <div className="menu-block">
                <label onClick={() => closeAll()}>
                  <Link href="/admissions" as="/admissions">
                    <a>Graduate</a>
                  </Link>
                </label>
                <ul>
                  <li onClick={() => closeAll()}>
                    <Link href="/admissions" as="/admissions">
                      <a alt="Apply Now">Apply Now</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link
                      href="/admissions/information"
                      as="/admissions/information"
                    >
                      <a>Information Sessions</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link
                      href="/admissions/tuition-fees"
                      as="/admissions/tuition-fees"
                    >
                      <a>Tuition & Fees</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link
                      href="/admissions/financial-aid"
                      as="/admissions/financial-aid"
                    >
                      <a>Financial Aid & Scholarships</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link href="/admissions" as="/admissions/scholarship-grant">
                      <a>Certificate in Islamic Chaplaincy</a>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="menu-block">
                {/* <label onClick={() => closeAll()}><Link href="/admissions#cost-and-aid" as="/admissions#cost-and-aid">
									<a >Affordability</a>
								</Link></label>
								<ul>
									<li onClick={() => closeAll()}><Link href="/admissions#tuition-and-aid" as="/admissions#tuition-and-aid" passHref>
										<a>Tuition & Aid</a>
									</Link></li>
									<li onClick={() => closeAll()}><Link href="/admissions#financial-aid" as="/admissions#financial-aid">
										<a>Financial Aid</a>
									</Link></li>
									<li onClick={() => closeAll()}><Link href="/admissions#scholarships" as="/admissions#scholarships">
										<a>Financial Assistance</a>
									</Link></li>
								</ul> */}
              </div>
              <div className="menu-block start-blk">
                <label>
                  <h3>Get Started Now!</h3>
                </label>
                <ul>
                  <li>
                    <Link
                      href="https://www.ctschicago.edu/bayanchicago/"
                      as="https://www.ctschicago.edu/bayanchicago/"
                    >
                      <a target="_blank" alt="Apply Now">
                        Apply Now
                      </a>
                    </Link>
                  </li>
                  <li>
                    {userId == null ? (
                      <a
                        className="btn-request-info-mbl"
                        onClick={props.RequestInfo}
                      >
                        Request Info
                      </a>
                    ) : null}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`menu-mobile-block ${openCommunityMenu ? "open" : ""}`}
          >
            <div className="menu-header">
              <a
                className="backarrow"
                onClick={() => setOpenCommunityMenu(false)}
              >
                <img
                  src="https://d310ox1f4zno4b.cloudfront.net/static-content/arrow.png.webp"
                  width="14"
                />
              </a>
              <label>Community</label>
              <a className="close-icon" onClick={() => closeAll()}></a>
            </div>
            <div className="menu-body">
              <div className="menu-block">
                <label onClick={() => closeAll()}>
                  <Link href="/student-resources" as="/student-resources">
                    <a>Student Resources</a>
                  </Link>
                </label>
                <ul>
                  <li onClick={() => closeAll()}>
                    <a target="_blank" href="https://mycts.ctschicago.edu/">
                      Student Portal
                    </a>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link href="/student-resources" as="/student-resources">
                      <a>Canvas LMS</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    {" "}
                    <Link href="/student-resources" as="/student-resources">
                      <a>Library</a>
                    </Link>
                  </li>
                </ul>
              </div>
              {/* <div className="menu-block">
                <label onClick={() => closeAll()}>
                  <Link href="/community" as="/community">
                    <a>Join Our Community</a>
                  </Link>
                </label>
                <ul>
                  <li onClick={() => closeAll()}>
                    <Link href="/download-app" as="/download-app">
                      <a>Download the app</a>
                    </Link>
                  </li>
                </ul>
              </div> */}
              {/* <div className="menu-block">
								<label onClick={() => closeAll()}><Link href="/register" as="/register">
									<a>Connect with</a>
								</Link></label>
								<ul>
									<li onClick={() => closeAll()}><Link href="/register" as="/register" passHref>
										<a>Students</a>
									</Link></li>
									<li onClick={() => closeAll()}><Link href="/register" as="/register">
										<a>Alumni</a>
									</Link></li>
									<li onClick={() => closeAll()}><Link href="/register" as="/register">
										<a>Faculty</a>
									</Link></li>
									<li onClick={() => closeAll()}><Link href="/register" as="/register">
										<a>Leadership</a>
									</Link></li>
									<li onClick={() => closeAll()}><Link href="/register" as="/register">
										<a>Staff</a>
									</Link></li>
								</ul>
							</div> */}
            </div>
          </div>
          <div className={`menu-mobile-block ${openAboutMenu ? "open" : ""}`}>
            <div className="menu-header">
              <a className="backarrow" onClick={() => setOpenAboutMenu(false)}>
                <img
                  src="https://d310ox1f4zno4b.cloudfront.net/static-content/arrow.png.webp"
                  width="14"
                />
              </a>
              <label>About</label>
              <a className="close-icon" onClick={() => closeAll()}></a>
            </div>
            <div className="menu-body">
              <div className="menu-block">
                <label onClick={() => closeAll()}>
                  <Link href="/about" as="/about">
                    <a>About Bayan</a>
                  </Link>
                </label>
                <ul>
                  <li onClick={() => closeAll()}>
                    <Link
                      href="/about#mission-and-vision"
                      as="/about#mission-and-vision"
                      passHref
                    >
                      <a>Mission & Vision</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link href="/about#accreditation" as="/about#accreditation">
                      <a>Accreditation</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link
                      href="/about#partner-schools"
                      as="/about#partner-schools"
                    >
                      <a>Partner Institutions</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link href="/about/philosophy" as="/about/philosophy">
                      <a>Philosophy</a>
                    </Link>
                  </li>
                  <li onClick={() => closeAll()}>
                    <Link href="/leadership" as="/leadership">
                      <a>Leadership</a>
                    </Link>
                  </li>
                  {/* <li onClick={() => closeAll()}>
                    <Link href="/faculty" as="/faculty">
                      <a>Faculty</a>
                    </Link>
                  </li> */}
                  <li onClick={() => closeAll()}>
                    <Link href="/staff" as="/staff">
                      <a>Staff</a>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="menu-block">
                <label onClick={() => closeAll()}>
                  <Link href="/news-events" as="/news-events">
                    <a>News & Events</a>
                  </Link>
                </label>
              </div>
              <div className="menu-block menu-socail-block">
                <label onClick={() => closeAll()}>
                  <Link href="/contact" as="/contact">
                    <a>Contact Us</a>
                  </Link>
                </label>
                <ul>
                  <li>
                    <Link href={socialLinks.facebook}>
                      <a target="_blank">
                        <img
                          src={`${process.env.IMAGES_BASE_URL}/static-content/fbook.png.webp`}
                          alt="Facebook Icon"
                        />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href={socialLinks.twitter}>
                      <a target="_blank">
                        <img
                          src={`${process.env.IMAGES_BASE_URL}/static-content/twitter.png.webp`}
                          alt="Twitter Icon"
                        />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href={socialLinks.youtube}>
                      <a target="_blank">
                        <img
                          src={`${process.env.IMAGES_BASE_URL}/static-content/youtube.png.webp`}
                          alt="Youtube Icon"
                        />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href={socialLinks.instagram}>
                      <a target="_blank">
                        <img
                          src={`${process.env.IMAGES_BASE_URL}/static-content/instagram.png.webp`}
                          alt="Instagram Icon"
                        />
                      </a>
                    </Link>
                  </li>
                  <li>
                    <Link href={socialLinks.linkedin}>
                      <a target="_blank">
                        <img
                          src={`${process.env.IMAGES_BASE_URL}/static-content/linkediniconpng.png`}
                          alt="LinkedIn Icon"
                        />
                      </a>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withUserAgent(MenuIcon);
